:host {
  ti-card {
    &-container {
      padding: $polaris-space-4;
    }
  }

  a {
    /*
     Adapted from Global CSS: https://bitbucket.itg.ti.com/projects/DCTUI/repos/ticom-ui-global-css/browse/src/objects/_object.textwithicon.scss
     We can update this when iconText is added to core
     */

    color: $polaris-color-teal5;
    text-decoration: none;
    display: inline-flex;
    gap: $polaris-space-2;
    flex-flow: row nowrap;
    align-items: flex-start;
    min-height: $polaris-line-height-2;
    line-height: $polaris-line-height-2;

    @include mix-for-sizes-down(phone) {
      min-height: $polaris-line-height-3;
      line-height: $polaris-line-height-3;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  .ti-product-family__icon {
    height: $polaris-line-height-2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    flex-shrink: 0;
    margin-inline-start: $polaris-space-1;

    @include mix-for-sizes-down(phone) {
      height: $polaris-line-height-3;
    }
  }
}
